<template>
  <div>
    <div id="DatosSolicitante_div" class="w-100">
        <div  class="col-12 padding-div-low ">
          <div class="card-header">
            <h5>Datos de la persona que se presentará</h5>
            </div>
          <div class="area card-body">
            
            <div id="aviso-ventanas-emergentes" class="mb-2 contenedor-puntero">
                <h6><i class="fas fa-info-circle"></i>&nbsp;Nota</h6>
                <ul class="mb-0 pl-4">
                  <li >Asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b>, de lo contrario no podrá generar e imprimir su comprobante de cita. Una vez habilitadas las <b style='color:yellow;'>ventanas emergentes</b>, actualice esta página.</li>
                  <li v-if="!conSesion && informacionDeSolicitanteObtenida != undefined && informacionDeSolicitanteObtenida != null && !this.informacionDeSolicitanteObtenida.EsAbogado" >Si está registrado en el padrón de abogados, se le recomienda que inicie sesión para agendar su cita, de esta forma podrá consultar y/o cancelar sus citas en el apartado de "Mi Agenda".</li>
                </ul>
                <!-- <span style="text-align: justify; display:block;">Asegúrese de tener habilitadas las <b style='color:yellow;'>ventanas emergentes</b>, de lo contrario no podrá generar e imprimir su comprobante de cita. Una vez habilitadas las <b style='color:yellow;'>ventanas emergentes</b>, actualice esta página.</span> -->
            </div>
              <hr />
          <!-- Toggle Datos de Usuario / Otros datos -->
            <div v-if="conSesion" class="btn-group btn-group-toggle" data-toggle="buttons">
                <label id="toggleDatosUsuario" class="btn btn-secondary overwrapDeBotones active" @click="datosUsuarioRadio=true, otrosDatosRadio=false, cargarInformacionAlFormulario(informacionDeUsuarioObtenida, false, true)">
                    <input type="radio" name="options" id="radioInformacionUsuario" autocomplete="off"  checked>Datos de Usuario
                </label>
                <label id="toggleOtrosDatos" class="btn btn-secondary overwrapDeBotones" @click="otrosDatosRadio=true, datosUsuarioRadio=false, cargarInformacionAlFormulario(informacionDeSolicitanteObtenida, false, true)">
                    <input type="radio" name="options" id="radioInformacionCURP" autocomplete="off" >Ingresar otros datos
                </label>
            </div>
          <!-- CURP -->
            <div class="row">
              <div id="CURP_div" class= "col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3">
                <h6 class="text-form">Ingrese la CURP *</h6>
                <div class="col mr-1 p-0">
                  <input 
                    v-model="informacionParaPadre.InformacionDeSolicitante.CURP"
                    type="text"
                    id="CURP"
                    name="CURP"
                    :class="[!verificarCURP()  && mostrarErroresInput ? 'form-control border border-danger': 'form-control', 'textoMayusculas']"
                    placeholder="CURP"
                    v-mask="'AAAA######AAAAAAN#'"
                    v-on:keyup="cambioDeCURP($event)"
                    :readonly="bloquearCampos.CURP"
                  />
                </div>
              </div>
            </div>
          <!-- Nombres & Apellidos -->
            <div v-if="(!conSesion && verificarCURP(informacionParaPadre.InformacionDeSolicitante.CURP)) || (conSesion && (datosUsuarioRadio || (otrosDatosRadio && verificarCURP(informacionParaPadre.InformacionDeSolicitante.CURP))))">
              <div id="NombreCompletoPersona_div" class="row">
                <div id="NombrePersona_div" class= "col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3">
                  <h6 class="text-form">Nombre(s) *</h6>
                  <input 
                    type="text" 
                    id="nombre" 
                    :class="[{'border border-danger': mostrarErroresInput && campoVacioONuloFormulario(this.informacionParaPadre.InformacionDeSolicitante.Nombres)}, 'form-control textoMayusculas']" 
                    placeholder="Ingrese el nombre" 
                    v-model="informacionParaPadre.InformacionDeSolicitante.Nombres" 
                    :readonly="bloquearCampos.nombreApellidos"
                    v-on:blur="informacionParaPadre.InformacionDeSolicitante.Nombres = obtenerCampoSinEspaciosInnecesarios(informacionParaPadre.InformacionDeSolicitante.Nombres)"
                    required
                  />
                </div>
                <div id="PrimerApellidoPersona_div" class= "col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3">
                  <h6 class="text-form">Primer Apellido *</h6>
                  <input 
                    type="text" 
                    id="primerApellido" 
                    :class="[mostrarErroresInput && campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.PrimerApellido) ? 'form-control border border-danger': 'form-control', 'textoMayusculas']" 
                    placeholder="Ingrese el primer apellido" 
                    v-model="informacionParaPadre.InformacionDeSolicitante.PrimerApellido" 
                    v-on:blur="informacionParaPadre.InformacionDeSolicitante.PrimerApellido = obtenerCampoSinEspaciosInnecesarios(informacionParaPadre.InformacionDeSolicitante.PrimerApellido)"
                    :readonly="bloquearCampos.nombreApellidos"
                  />
                </div>
                <div id="SegundoApellidoPersona_div" class= "col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3">
                  <h6 class="text-form">Segundo Apellido *</h6>
                  <input 
                    type="text" 
                    id="segundoApellido" 
                    :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.PrimerApellido) && campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.SegundoApellido)) ? 'form-control border border-danger': 'form-control', 'textoMayusculas']" 
                    placeholder="Ingrese el segundo apellido" 
                    v-model="informacionParaPadre.InformacionDeSolicitante.SegundoApellido" 
                    v-on:blur="informacionParaPadre.InformacionDeSolicitante.SegundoApellido = obtenerCampoSinEspaciosInnecesarios(informacionParaPadre.InformacionDeSolicitante.SegundoApellido)"
                    :readonly="bloquearCampos.nombreApellidos"
                  />
                </div>
              </div>
            <!-- Correo y confirmación de correo -->
              <div class="row">
                <div v-if="conSesion && datosUsuarioRadio && (informacionParaPadre.InformacionDeSolicitante.CorreoElectronico != informacionParaPadre.correoBase)" :class="seIngresoCorreo ? 'col-12 col-sm-12 col-md-12 col-lg-8 col-xlg-6':'col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3'">
                  <div class="contenedor-puntero mt-1 mb-1 p-1">
                    <h6 class="mb-0" style="display:inline-block;"><i class="fas fa-info-circle"></i>&nbsp;Nota: </h6>
                    <span class="p-1" style="display:inline-block;">{{mensajeCorreoUsuarioModificado}}</span>
                  </div>
                </div>
                <div v-if="!conSesion && informacionDeSolicitanteObtenida != undefined && informacionDeSolicitanteObtenida != null && this.informacionDeSolicitanteObtenida.EsAbogado" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3">
                  <div class="contenedor-puntero mt-1 mb-1 p-1">
                    <h6 class="mb-0" style="display:inline-block;"><i class="fas fa-info-circle"></i>&nbsp;Nota: </h6>
                    <span class="p-1" style="display:inline-block;">{{mensajeCorreoUsuarioParaModificar}}</span>
                  </div>
                </div>
              </div>
              <div id="InformacionExtra_div" class="row">
                <div id="Correo_div" class= "col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3">
                  <div><h6 style="display:inline-block" class="text-form">Correo personal * </h6><span v-if="mostrarMensajeCorreoPersonal" class="text-danger pl-3" style="display:inline-block">  {{mensajeCorreoPersonal}}</span></div>
                  <input 
                    type="email" 
                    id="correo" 
                    :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.CorreoElectronico) || !verificarCorreo(false, false)) ? 'form-control border border-danger': 'form-control']" 
                    placeholder="Ingrese el correo" 
                    v-model="informacionParaPadre.InformacionDeSolicitante.CorreoElectronico" 
                    :readonly="bloquearCampos.correo"
                    v-on:keyup="verificarCorreo(false, false)"
                    v-on:blur="verificarCorreo(false, true)"
                  />
                </div>
                <div id="CorreoConfirmacion_div" class= "col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3" v-if="!bloquearCampos.correo && seIngresoCorreo && (informacionParaPadre.InformacionDeSolicitante.CorreoElectronico != informacionParaPadre.correoBase)">
                  <div><h6 style="display:inline-block" class="text-form">Confirma Correo * </h6><span v-if="mostrarMensajeConfirmacionCorreo" class="text-danger pl-3" style="display:inline-block">  {{mensajeConfirmacionCorreo}}</span></div>
                  <input 
                    type="email" 
                    id="correoConfirmacion" 
                    :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.CorreoElectronicoConfirmar) || !verificarCorreo(true, true)) ? 'form-control border border-danger': 'form-control']" 
                    placeholder="Ingrese nuevamente el correo" 
                    v-model="informacionParaPadre.InformacionDeSolicitante.CorreoElectronicoConfirmar"
                    v-on:blur="verificarCorreo(true, true)"
                  />
                </div>
              <!-- Telefonos Extensiones -->
                <div id="Telefono_div" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3 ml-0">
                  <h6 class="text-form">Teléfono * y extensión</h6>
                  <div v-if="(conSesion == true && otrosDatosRadio==true) || (conSesion == false && (informacionDeSolicitanteObtenida.Telefonos == undefined || informacionDeSolicitanteObtenida.Telefonos == null) && !this.informacionDeSolicitanteObtenida.EsAbogado)" class="row m-0">
                    <div class="col mr-1 p-0">
                      <input 
                        v-model="informacionParaPadre.InformacionDeSolicitante.Telefono"
                        type="text"
                        id="numeroTelefonico"
                        name="numeroTelefonico"
                        :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.Telefono) || informacionParaPadre.InformacionDeSolicitante.Telefono.length < 10) ? 'form-control border border-danger': 'form-control']"
                        placeholder="Número telefónico"
                        v-mask="'##########'" 
                        :readonly="bloquearCampos.telefonoExtension"
                      />
                    </div>
                    <div class="col ml-1 mr-1 p-0">
                      <input 
                        v-model="informacionParaPadre.InformacionDeSolicitante.Extension"
                        type="text"
                        id="extension"
                        name="extension"
                        :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.Telefono) || informacionParaPadre.InformacionDeSolicitante.Telefono.length < 10) ? 'form-control border border-danger': 'form-control']"
                        placeholder="Extensión"
                        v-mask="'####'" 
                        :readonly="bloquearCampos.telefonoExtension"
                    />
                    </div>
                  </div>
                  <div v-if="(conSesion == true && datosUsuarioRadio == true && informacionDeUsuarioObtenida != null && informacionDeUsuarioObtenida != undefined && informacionDeUsuarioObtenida.Telefonos != undefined && informacionDeUsuarioObtenida.Telefonos != null)">
                    <select v-if="informacionDeUsuarioObtenida.Telefonos.length >  0" id="selectTelefonos" v-model="idDeTelefono" :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.Telefono) || idDeTelefono<=0) ? 'form-control border border-danger': 'form-control']" @change="cambiarSelectTelefono($event, informacionDeUsuarioObtenida.Telefonos)" :disabled="false">
                      <option :value="enumeraciones.tiposDeSelect.Seleccione.Id">{{enumeraciones.tiposDeSelect.Seleccione.Nombre}} un Teléfono </option>
                      <option v-for="Telefono in informacionDeUsuarioObtenida.Telefonos" :value="Telefono.TelefonoId" :key="Telefono.TelefonoId">{{obtenerTextoOpcionTelefono(Telefono.Numero, Telefono.Extension)}}</option>
                    </select>
                    <div v-else>
                      <span class="text-warning" style="display:inline-block"> No se encontraron teléfonos registrados, favor de pasar a actualizar su información</span>
                    </div>
                  </div>
                  <div  v-if="(conSesion == false && informacionDeSolicitanteObtenida != undefined && informacionDeSolicitanteObtenida != null && (informacionDeSolicitanteObtenida.Telefonos != undefined || informacionDeSolicitanteObtenida.Telefonos != null))">
                    <select v-if="informacionDeSolicitanteObtenida.Telefonos.length >  0" id="selectTelefonos" v-model="idDeTelefono" :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.Telefono) || idDeTelefono<=0) ? 'form-control border border-danger': 'form-control']" @change="cambiarSelectTelefono($event, informacionDeSolicitanteObtenida.Telefonos)" :disabled="false">
                      <option :value="enumeraciones.tiposDeSelect.Seleccione.Id">{{enumeraciones.tiposDeSelect.Seleccione.Nombre}} un Teléfono </option>
                      <option v-for="Telefono in informacionDeSolicitanteObtenida.Telefonos" :value="Telefono.TelefonoId" :key="Telefono.TelefonoId">{{obtenerTextoOpcionTelefono(Telefono.Numero, Telefono.Extension)}}</option>
                    </select>
                    <div v-else-if="this.informacionDeSolicitanteObtenida.EsAbogado">
                      <span class="text-warning" style="display:inline-block"> No se encontraron teléfonos registrados, favor de pasar a actualizar su información</span>
                    </div>
                  </div>
                </div>
              </div>
            <!-- Fecha de nacimiento -->
              <div class="row">
                <div id="FechaNacimiento_div" class="col-12 col-sm-12 col-md-6 col-lg-4 col-xlg-3 mb-3">
                  <h6 class="text-form">Ingrese la fecha de nacimiento *</h6>
                  <input 
                    v-model="informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento" 
                    type="date" 
                    id="fechaNacimiento" 
                    :min="fechaMinima"
                    :max="fechaMaxima"
                    :class="[mostrarErroresInput && (campoVacioONuloFormulario(informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento)) ? 'form-control border border-danger': 'form-control']"
                    v-on:blur="cambiarDateFechaDeNacimiento($event)"
                    :readonly="bloquearCampos.fechaDeNacimiento"
                    /> 
                </div>
              </div>
            </div>
            <hr />
            <div class="text-right" style="margin-top: 20px;" v-if="(!conSesion && verificarCURP()) || (conSesion && (datosUsuarioRadio || (otrosDatosRadio && verificarCURP())))">
              <div>
                  <button type="button" class="btn btn-primary" @click="crearObjetoDatosUsuarioYSiguiente"><i class="fas fa-arrow-alt-circle-right fa-lg"></i>&nbsp;&nbsp;Siguiente</button>
              </div> 
            </div> 
          </div>
        </div>
    </div>
  </div>
</template>

<script>
  import enumeraciones from '@/../static/js/enumeraciones'
  import api from '@/../static/js/api'
  import comun from '@/../static/js/comun'
  import axios from 'axios'
  import VueMask from "v-mask";


  Vue.use(VueMask);

  export default {
    data() {
      return {
        enumeraciones,
        api,
        fechaMinima: moment().add(-100, 'years').format('YYYY-MM-DD'),
        fechaMaxima: moment().add(-18, 'years').format('YYYY-MM-DD'),
        mostrarErroresInput: false,
        verificarVentanas: true,
        informacionParaPadre:
        {
          EsInformacionUsuario: false,
          tieneSesion: false,
          esError:false,
          correoBase:"",
          InformacionDeSolicitante:{
            CURP:"", 
            Nombres:"", 
            PrimerApellido:"",
            SegundoApellido:"",
            CorreoElectronico:"",
            CorreoElectronicoConfirmar:"",
            Telefono:"", 
            Extension:"",
            FechaDeNacimiento:"",
            valorToggleUsuario: false
          }
        },
        informacionDeUsuarioObtenida:{
          correoBase:"",
          bloquearCampos:{
            nombreApellidos: false,
            telefonoExtension:false,
            CURP:false,
            fechaDeNacimiento:false,
            correo: false
          }
        },
        informacionDeSolicitanteObtenida:{
          correoBase:"",
          EsAbogado:false,
          bloquearCampos:{
            nombreApellidos: false,
            telefonoExtension:false,
            CURP:false,
            fechaDeNacimiento:false,
            correo: false
          }
        },
        datosUsuarioRadio:true,
        otrosDatosRadio:false,
        conSesion:false,
        bloquearCampos:{
          nombreApellidos: false,
          telefonoExtension:false,
          CURP:false,
          fechaDeNacimiento:false,
          correo: false
        },
        idDeTelefono:-1,
        indexTelefono: -1,
        mensajeCamposFaltantes: '',
        mensajeCorreoPersonal:'',
        mensajeCorreoUsuarioModificado:'Se le harán llegar los avisos referentes a su cita al correo ingresado, este no afecta los datos de su inicio de sesión.',
        mensajeCorreoUsuarioParaModificar:'Si desea cambiar su correo electrónico, agende su cita iniciando sesión.',
        mostrarMensajeCorreoPersonal:false,
        mensajeConfirmacionCorreo:'',
        mostrarMensajeConfirmacionCorreo:false,
        mensajeFechaDeNacimiento:'',
        mostrarMensajeFechaDeNacimiento:false,
        seIngresoCorreo: false,
        parametros: {}
      }
    },
    components: {
    },
    methods: {
      /**
       * Función encargada de obtener la información de solicitante dado una CURP o si el usuario tiene cuenta su información
       */
      obtenerInformacionSesionCURP: function(){
        if(this.conSesion && this.otrosDatosRadio && this.informacionDeUsuarioObtenida.CURP != undefined &&  this.informacionDeUsuarioObtenida.CURP != null  && this.informacionDeUsuarioObtenida.CURP == this.informacionParaPadre.InformacionDeSolicitante.CURP)
        {
          comun.mensajeDeAlerta("Su información de usuario ya está cargada, de clic en 'Datos de Usuario' para visualizarla.", null, null);
          this.informacionParaPadre.InformacionDeSolicitante.CURP = "";
        }
        else
        { 
          this.parametros.EsPrueba = this.enumeraciones.EsPrueba 
          const headerPeticion = comun.CrearElHeaderDeAutorizacion(this.$store.state.Login_AutorizacionOriginal, false);    

          comun.SeEstaCargandoInformacion(true); 
          axios
            .post(
              api.conexion + api.SICCIJ.sistema.citas.AgendarCita.VerificarYObtenerDatosDeSolicitante, 
              this.parametros, 
              headerPeticion)
            .then(respuesta => 
            {            
              // SI HAY ERROR
              if (respuesta.data.SiHayError) 
              {
                comun.SeEstaCargandoInformacion(false); 
                console.log(respuesta);
                
                // ERROR TRATANDO DE CONSULTAR INFORMACIÓN DESDE CURP
                if(this.parametros.ObtenerInformacionDeCURP)
                {
                  //LA CURP NO SE ENCONTRÓ
                  if((respuesta.data.Error.Mensaje.includes("La CURP no fue encontrada")))
                  {
                    this.limpiarInformacion(this.informacionDeSolicitanteObtenida, this.informacionParaPadre.InformacionDeSolicitante.CURP);
                      let fecha = this.informacionParaPadre.InformacionDeSolicitante.CURP.substring(4,10);
                      let fechaGenerada = this.obtenerAñoDeFechaDeNacimiento(fecha.substring(0,2)) + "-" + fecha.substring(2,4) + "-" + fecha.substring(4,6);
                      if(this.verificarFechaDeNacimiento(fechaGenerada))
                        this.informacionDeSolicitanteObtenida.FechaDeNacimiento = moment(fechaGenerada).format('YYYY-MM-DD');
                    this.cargarInformacionAlFormulario(this.informacionDeSolicitanteObtenida, true, false);
                  }
                  //INTENTO DE AGENDAR PARA OTRO ABOGADO
                  if(respuesta.data.Error.Mensaje.includes("No puede agendar una cita para otro abogado"))
                  {
                    this.limpiarInformacion(this.informacionDeSolicitanteObtenida, ""); 
                    this.cargarInformacionAlFormulario(this.informacionDeSolicitanteObtenida, true, false);
                  }
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                }
                else
                {
                  comun.mensajeDeAlerta(respuesta.data.Error.Mensaje, null, null);
                  this.$emit("valorParaElPadreInformacionSolicitante", null);
                }
              } 
              // SI SE OBTUVO INFORMACIÓN
              else 
              {
                comun.SeEstaCargandoInformacion(false);  
                this.informacionDeUsuarioObtenida.bloquearCampos.nombreApellidos = false;
                // INFORMACIÓN DESDE USUARIO
                if(respuesta.data.HayRegistroUsuario == true)
                {
                  //ID's
                  this.informacionDeUsuarioObtenida.InformacionDeSolicitanteId = respuesta.data.InformacionConsultada.InformacionDeSolicitanteId;
                  this.informacionDeUsuarioObtenida.Usuario_PJId = respuesta.data.InformacionConsultada.Usuario_PJId;
                  //HAY CURP, ASIGNAR
                  if(respuesta.data.InformacionConsultada.CURP!=null && respuesta.data.InformacionConsultada.CURP!=undefined)
                  {
                    this.informacionDeUsuarioObtenida.bloquearCampos.CURP = true;
                    this.informacionDeUsuarioObtenida.CURP = respuesta.data.InformacionConsultada.CURP;
                  }
                  //NOMBRE Y APELLIDOS
                  this.informacionDeUsuarioObtenida.Nombres = respuesta.data.InformacionConsultada.Nombres;
                  this.informacionDeUsuarioObtenida.PrimerApellido = respuesta.data.InformacionConsultada.PrimerApellido;
                  this.informacionDeUsuarioObtenida.SegundoApellido = respuesta.data.InformacionConsultada.SegundoApellido;
                  if(this.informacionDeUsuarioObtenida.Nombres != null && (this.informacionDeUsuarioObtenida.PrimerApellido != null || this.informacionDeUsuarioObtenida.SegundoApellido != null))
                    this.informacionDeUsuarioObtenida.bloquearCampos.nombreApellidos = true;
                  //CORREO ELECTRÓNICO
                  this.informacionDeUsuarioObtenida.CorreoElectronico = respuesta.data.InformacionConsultada.CorreoElectronico;
                  this.informacionDeUsuarioObtenida.correoBase = respuesta.data.InformacionConsultada.CorreoElectronico;
                  this.informacionDeUsuarioObtenida.bloquearCampos.correo = false;
                  //FECHA DE NACIMIENTO
                  if(respuesta.data.InformacionConsultada.FechaDeNacimiento > this.fechaMinima)
                  {
                    this.informacionDeUsuarioObtenida.FechaDeNacimiento = moment(respuesta.data.InformacionConsultada.FechaDeNacimiento).format('YYYY-MM-DD');
                    this.informacionDeUsuarioObtenida.bloquearCampos.fechaDeNacimiento = true;
                  }
                  if(respuesta.data.InformacionConsultada.CURP && 
                     (!this.verificarFechaDeNacimiento(respuesta.data.InformacionConsultada.FechaDeNacimiento)))
                  {
                    let fecha = respuesta.data.InformacionConsultada.CURP.substring(4,10);
                    let fechaGenerada = this.obtenerAñoDeFechaDeNacimiento(fecha.substring(0,2)) + "-" + fecha.substring(2,4) + "-" + fecha.substring(4,6);
                    if(this.verificarFechaDeNacimiento(fechaGenerada))
                      this.informacionDeUsuarioObtenida.FechaDeNacimiento = moment(fechaGenerada).format('YYYY-MM-DD');
                    this.informacionDeUsuarioObtenida.bloquearCampos.fechaDeNacimiento = false;
                  }
                  //TELEFONOS
                  this.informacionDeUsuarioObtenida.Telefonos = respuesta.data.TelefonosUsuario;
                  if(this.campoNoEstaVacio(respuesta.data.InformacionConsultada.InformacionDeSolicitanteId))
                  {
                    const telId = this.informacionDeUsuarioObtenida.Telefonos.findIndex(tel => tel.Numero.match(/[0123456789]/gi).join("") === respuesta.data.InformacionConsultada.Telefono); 
                    if(this.campoNoEstaVacio(this.informacionDeUsuarioObtenida.Telefonos[telId]))
                    {
                      this.informacionDeUsuarioObtenida.Telefono = respuesta.data.InformacionConsultada.Telefono;
                      this.informacionDeUsuarioObtenida.Extension = respuesta.data.InformacionConsultada.Extension;
                      this.idDeTelefono = this.informacionDeUsuarioObtenida.Telefonos[telId].TelefonoId;
                    }
                  }
                  this.conSesion = true;
                  this.tieneSesion = true;
                  this.cargarInformacionAlFormulario(this.informacionDeUsuarioObtenida, true, false);
                }
                // INFORMACIÓN DESDE CURP
                else if(respuesta.data.HayRegistroCURP == true)
                {
                  //ID's
                  this.informacionDeSolicitanteObtenida.InformacionDeSolicitanteId = respuesta.data.InformacionConsultada.InformacionDeSolicitanteId
                  //CURP
                  this.informacionDeSolicitanteObtenida.CURP = respuesta.data.InformacionConsultada.CURP;
                  this.informacionDeSolicitanteObtenida.bloquearCampos.CURP = false;
                  //NOMBRE Y APELLIDOS
                  this.informacionDeSolicitanteObtenida.Nombres = respuesta.data.InformacionConsultada.Nombres;
                  this.informacionDeSolicitanteObtenida.PrimerApellido = respuesta.data.InformacionConsultada.PrimerApellido;
                  this.informacionDeSolicitanteObtenida.SegundoApellido = respuesta.data.InformacionConsultada.SegundoApellido;
                  this.informacionDeSolicitanteObtenida.bloquearCampos.nombreApellidos = this.campoNoEstaVacio(respuesta.data.InformacionConsultada.Nombres);
                  //CORREO ELECTRÓNICO
                  this.informacionDeSolicitanteObtenida.CorreoElectronico = respuesta.data.InformacionConsultada.CorreoElectronico;
                  this.informacionDeSolicitanteObtenida.correoBase = respuesta.data.InformacionConsultada.CorreoElectronico;
                  this.informacionDeSolicitanteObtenida.bloquearCampos.correo = false;//this.campoNoEstaVacio(respuesta.data.InformacionConsultada.CorreoElectronico);
                  //FECHA DE NACIMIENTO
                  this.informacionDeSolicitanteObtenida.FechaDeNacimiento = this.verificarFechaDeNacimiento(respuesta.data.InformacionConsultada.FechaDeNacimiento)? moment(respuesta.data.InformacionConsultada.FechaDeNacimiento).format('YYYY-MM-DD') : null;
                  if(respuesta.data.InformacionConsultada.CURP && 
                     (!this.verificarFechaDeNacimiento(respuesta.data.InformacionConsultada.FechaDeNacimiento)))
                  {
                    let fecha = respuesta.data.InformacionConsultada.CURP.substring(4,10);
                    let fechaGenerada = this.obtenerAñoDeFechaDeNacimiento(fecha.substring(0,2)) + "-" + fecha.substring(2,4) + "-" + fecha.substring(4,6);
                    if(this.verificarFechaDeNacimiento(fechaGenerada))
                      this.informacionDeSolicitanteObtenida.FechaDeNacimiento = moment(fechaGenerada).format('YYYY-MM-DD');
                    this.informacionDeSolicitanteObtenida.bloquearCampos.fechaDeNacimiento = false;
                  }
                  this.informacionDeSolicitanteObtenida.bloquearCampos.fechaDeNacimiento = this.campoNoEstaVacio(respuesta.data.InformacionConsultada.FechaDeNacimiento);
                  //TELEFONOS
                  this.informacionDeSolicitanteObtenida.Telefono = respuesta.data.InformacionConsultada.Telefono;
                  this.informacionDeSolicitanteObtenida.Extension = respuesta.data.InformacionConsultada.Extension;
                  if(this.campoNoEstaVacio(respuesta.data.InformacionConsultada.Usuario_PJId))
                  {
                    this.informacionDeSolicitanteObtenida.Telefonos = respuesta.data.TelefonosUsuario;
                    const telId = this.informacionDeSolicitanteObtenida.Telefonos.findIndex(tel => tel.Numero.match(/[0123456789]/gi).join("") === respuesta.data.InformacionConsultada.Telefono); 
                    if(this.campoNoEstaVacio(this.informacionDeSolicitanteObtenida.Telefonos[telId]))
                    {
                      //$('#selectTelefonos').val(telId);
                      this.idDeTelefono = this.informacionDeSolicitanteObtenida.Telefonos[telId].TelefonoId;
                    }
                    this.informacionDeSolicitanteObtenida.bloquearCampos.correo = true;
                  }
                  else
                  {
                    this.informacionDeSolicitanteObtenida.Telefonos = null;
                    this.idDeTelefono = -1;
                  }
                  //INFORMACIÓN DE USUARIO
                  this.informacionDeSolicitanteObtenida.EsAbogado = respuesta.data.EsAbogado;   
                  this.informacionDeSolicitanteObtenida.Usuario_PJId = respuesta.data.InformacionConsultada.Usuario_PJId;
                  this.cargarInformacionAlFormulario(this.informacionDeSolicitanteObtenida, true, false);
                }
              }
            })
            .catch(excepcion => 
            {
              console.log(excepcion);
              comun.mensajeDeAlerta(comun.mensajeDeError(this.enumeraciones.error.E500), null, null)
            })
        }
      },
      /**
       * Fecha encargada de obtener campos eliminado espacios
       */
      obtenerCampoSinEspaciosInnecesarios:function(texto)
      {
        return texto.replace(/\s+/g,' ').replace(/^\s+|\s+$/,'');
      },
      /**
       * Función encargada de obtener el año completo de la fecha de nacimientos de la CURP
       * @param {String} año [dígitos del año de la CURP]
       */
      obtenerAñoDeFechaDeNacimiento:function(año)
      {
        let añoFechaHoy = moment().format('YYYY');
        let añoCompleto = año > añoFechaHoy.substring(2,4) ?  "19" + año : "20" + año;
        return añoCompleto;
      },
      /**
       * Función encargada de crear objeto de datos de solicitante y enviarlo al componente padre de Agendar de cita
       */
      crearObjetoDatosUsuarioYSiguiente: function(){
        if(this.verificarCamposFormulario())
        {
          this.informacionParaPadre.EsInformacionUsuario = this.conSesion && this.datosUsuarioRadio;
          this.$emit("valorParaElPadreInformacionSolicitante", this.informacionParaPadre);
        }
        else
        {
          comun.mensajeDeAlerta(this.mensajeCamposFaltantes, null, null);
          this.mostrarErroresInput = true;
        }
      },
      /**
       * Función encargada de cargar la información obtenida al solicitante y guardar lo que esté en el formulario
       * @param {Object} datos [información de solicitante con la que se llenará el formulario]
       * @param {Bool} infoDesdeAPI [valor que indica si la información de solicitante fue obtenida desde API]
       * @param {Bool} desdeToggle [valor que indica si se debe cambiar la información de solicitante por cambio del toggle]
       */
      cargarInformacionAlFormulario: function(datos, infoDesdeAPI, desdeToggle){
        //!(Object.keys(this.informacionParaPadre.InformacionDeSolicitante).length === 0)
        //ACTUALIZAR INFORMACIÓN OBTENIDA DESDE USUARIO Y CURP, CON EL FORMULARIO
        if(!infoDesdeAPI && this.conSesion)
        {
          //ACTUALIZAR INFORMACIÓN DE USUARIO
          if(!this.datosUsuarioRadio && this.informacionParaPadre.InformacionDeSolicitante.valorToggleUsuario)
          {
            if(!this.campoNoEstaVacio(this.informacionDeUsuarioObtenida.CURP) || this.informacionDeUsuarioObtenida.CURP.length < 18 )
              this.informacionDeUsuarioObtenida.CURP = this.informacionParaPadre.InformacionDeSolicitante.CURP;
            if(this.idDeTelefono != -1)
            {
              this.informacionDeUsuarioObtenida.Telefono = this.informacionParaPadre.InformacionDeSolicitante.Telefono;
              this.informacionDeUsuarioObtenida.Extension = this.informacionParaPadre.InformacionDeSolicitante.Extension;
            }
            if(!this.campoNoEstaVacio(this.informacionDeUsuarioObtenida.FechaDeNacimiento))
            {
              this.informacionDeUsuarioObtenida.FechaDeNacimiento = this.verificarFechaDeNacimiento(this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento)? moment(this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento).format('YYYY-MM-DD') : null;
            }
            this.informacionDeUsuarioObtenida.CorreoElectronico = this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico; 
          }
          //ACTUALIZAR INFORMACIÓN DESDE CURP
          else if(!this.otrosDatosRadio && !this.informacionParaPadre.InformacionDeSolicitante.valorToggleUsuario)
          {
              this.informacionDeSolicitanteObtenida.CURP = this.informacionParaPadre.InformacionDeSolicitante.CURP;
              this.informacionDeSolicitanteObtenida.InformacionDeSolicitanteId = this.informacionParaPadre.InformacionDeSolicitante.InformacionDeSolicitanteId;
              this.informacionDeSolicitanteObtenida.Nombres = this.informacionParaPadre.InformacionDeSolicitante.Nombres;
              this.informacionDeSolicitanteObtenida.PrimerApellido = this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido;
              this.informacionDeSolicitanteObtenida.SegundoApellido = this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido;
              this.informacionDeSolicitanteObtenida.CorreoElectronico = this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico;
              this.informacionDeSolicitanteObtenida.FechaDeNacimiento = this.verificarFechaDeNacimiento(this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento)? moment(this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento).format('YYYY-MM-DD') : null;
              this.informacionDeSolicitanteObtenida.Telefono = this.informacionParaPadre.InformacionDeSolicitante.Telefono;
              this.informacionDeSolicitanteObtenida.Extension = this.informacionParaPadre.InformacionDeSolicitante.Extension;
          }
        }
        //LLENAR INFORMACIÓN DE FORMULARIO
        this.informacionParaPadre.InformacionDeSolicitante.valorToggleUsuario = this.datosUsuarioRadio; 
        this.informacionParaPadre.InformacionDeSolicitante.CURP = datos.CURP;
        this.informacionParaPadre.InformacionDeSolicitante.InformacionDeSolicitanteId = datos.InformacionDeSolicitanteId
        this.informacionParaPadre.InformacionDeSolicitante.Usuario_PJId = datos.Usuario_PJId;
        this.informacionParaPadre.InformacionDeSolicitante.Nombres = datos.Nombres;
        this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido = datos.PrimerApellido;
        this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido = datos.SegundoApellido;
        this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico = datos.CorreoElectronico;
        this.informacionParaPadre.correoBase = datos.correoBase;
        this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento = datos.FechaDeNacimiento;
        this.informacionParaPadre.InformacionDeSolicitante.Telefono = datos.Telefono;
        if(datos.Telefonos!= null)
        {
          const telId = datos.Telefonos.findIndex(tel => tel.Numero.match(/[0123456789]/gi).join("") === datos.Telefono); 
          if(this.campoNoEstaVacio(datos.Telefonos[telId]))
          {
            this.idDeTelefono = datos.Telefonos[telId].TelefonoId;
          }
        }
        this.informacionParaPadre.InformacionDeSolicitante.Extension = datos.Extension;
        this.bloquearCampos.fechaDeNacimiento = datos.bloquearCampos.fechaDeNacimiento;
        this.bloquearCampos.nombreApellidos = datos.bloquearCampos.nombreApellidos;
        this.bloquearCampos.CURP = datos.bloquearCampos.CURP;
        this.bloquearCampos.correo = datos.bloquearCampos.correo;
        
      },
      /**
       * Función que desencadena al modificar el campo de CURP y se encarga de llenar la petición para la busqueda de CURP contra API y llama a la unción encargada con llamar a API
       * @param {String} datosCURP [valor que representa el estado en que se encuentra la directiva]
       */
      cambioDeCURP(datosCURP)
      {
        var CURP = datosCURP.target.value;
        if(CURP.length == 18)
        {
          if(((this.conSesion && this.otrosDatosRadio) || !this.conSesion) && (this.informacionDeSolicitanteObtenida.CURP == null || 
             this.informacionDeSolicitanteObtenida.CURP == undefined ||
             this.informacionDeSolicitanteObtenida.CURP.toUpperCase() != CURP.toUpperCase()))
             {
               this.parametros = {CURP : this.informacionParaPadre.InformacionDeSolicitante.CURP, ObtenerInformacionDeUsuario : false, ObtenerInformacionDeCURP : true}
               this.obtenerInformacionSesionCURP();
             }
          else if(this.conSesion && this.datosUsuarioRadio){}
        }
      },
      /**
       * Función encargada de obtener el teléfono y extensión de un telefono seleccionado desde el select y asignarlo al objeto de información de solicitante.
       * @param {String} datosTelefono [valor que representa el evento que se genera al cambiar el teléfono de un select]
       */
      cambiarSelectTelefono(datosTelefono, listadoTelefonos)
      {
        this.idDeTelefono = datosTelefono.target.value;
        if(datosTelefono.target.value > -1)
        {
          this.informacionParaPadre.InformacionDeSolicitante.Telefono = listadoTelefonos[datosTelefono.target.selectedIndex-1].Numero.match(/[0123456789]/gi).join("");
          this.informacionParaPadre.InformacionDeSolicitante.Extension = listadoTelefonos[datosTelefono.target.selectedIndex-1].Extension;
        }
      },
      /**
       * Función encargada de validar que la fecha de nacimiento esté dentro del rango permitido cuando se cambia desde el select y mostrar error de ser necesario.
       * @param {} fechaElegidaEvent [valor que representa el evento que se genera al cambiar la fecha del input]
       */
      cambiarDateFechaDeNacimiento(fechaElegidaEvent)
      {
        let fechaElegida = fechaElegidaEvent.target.value;
        if((fechaElegida > this.fechaMaxima))
        {
          comun.mensajeDeAlerta("La fecha no es válida, tiene que ser mayor de edad para poder asistir a una cita.", null, null);
          this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento = null;
        }
        else if((fechaElegida < this.fechaMinima))
        {
          comun.mensajeDeAlerta("La fecha está fuera del rango designado de edades. Ingrese la fecha de nacimiento correctamente de la persona que asistirá a la cita. <br>De ser correcta la fecha, comuniquese a Poder Judicial para solucionar su problema.", null, null);
          this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento = null;
        }
          
      },
      /**
       * Función encargada de confirmar que el campo proporcionado contenga algún valor
       * @param {String} estado [valor que representa el campo a verificar]
       */
      campoNoEstaVacio: function(campo) {
        let campoValido = true;
        if(campo == undefined || campo == null || campo == "" || campo.toString().trim() == "") { 
            campoValido = false;
        }
        return campoValido;
      },
      /**
       * Función encargada confirmar si el campo proporcionado es undefined o null o vacio
       * @param {String} campo [valor que representa el campo a verificar]
       */
      campoVacioONuloFormulario: function(campo) {
        return campo == undefined || campo == null || campo == "" || campo.toString().trim() == "";
      },
      /**
       * Función encargada de verificar si la CURP coincide con los nombres y fecha de nacimiento ingresada
       */
      verificarPorcentajeCoincidenciaCURP: function()
      {
        var curpValida = false;
        const curpBase = this.informacionParaPadre.InformacionDeSolicitante.CURP.substring(0,4).toUpperCase();
        const curpGenerada = this.obtenerPrimerasCuatroLetrasCURP();
        var tmpValue = 0;
        for(var i = 0; i < 4; i++) { 
          if(curpBase[i] == curpGenerada[i])
            tmpValue++; 
        } 
        var porcentaje = (tmpValue/4)*100 ; 

        const fechaCURP = this.informacionParaPadre.InformacionDeSolicitante.CURP.substring(4,10);
        const fechaNac = moment(this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento).format("YYMMDD");

        if(fechaCURP === fechaNac)
          curpValida = porcentaje >= 50;
      
        return curpValida; 
      },
      /**
       * Función encargada de obtener las primeras 4 letras de la curp
       */
      obtenerPrimerasCuatroLetrasCURP: function()
      {
        var nombresIgnorar = ['MARIA', 'MA', 'MA.', 'JOSE', 'J', 'J.'];
        var palabrasIgnorar = ['DA', 'DAS', 'DE', 'DEL', 'DER', 'DI', 'DIE', 'DD', 'EL', 'LA', 'LOS', 'LAS', 'LE', 'LES', 'MAC', 'MC', 'VAN', 'VON', 'Y'];
        var caracteresEspeciales = ['/','-','.']
        var letrasNombre;
        var curpGenerada;
        var nombres = [];
        var apellidosPat = [];
        var apellidosMat = [];

        if(this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido))
        {
          (this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido.trim().toUpperCase().split(' ')).forEach(primerAp => {
            if (!palabrasIgnorar.includes(primerAp)) { 
              apellidosPat.push(this.simplificarNombreApellidos(primerAp));
            }
          });
          if(apellidosPat.length > 0)
          {
            curpGenerada = apellidosPat[0].substring(0,1) + 
                            ((caracteresEspeciales.includes((apellidosPat[0])[1]) || !(apellidosPat[0].match(/[AEIOU]/gi).length > 0)) ? 
                            'X':
                            ((apellidosPat[0])[0].match(/[AEIOU]/gi) != null ? 
                            apellidosPat[0].match(/[AEIOU]/gi)[1] : 
                            apellidosPat[0].match(/[AEIOU]/gi)[0]));
          }
        }
        else curpGenerada = this.informacionParaPadre.InformacionDeSolicitante.CURP.substring(0,2).toUpperCase();

        if(this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido))
        {
          (this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido.trim().toUpperCase().split(' ')).forEach(segundoAp => {
            if (!palabrasIgnorar.includes(segundoAp)) { 
              apellidosMat.push(this.simplificarNombreApellidos(segundoAp));
            }
          });
          curpGenerada = curpGenerada + (apellidosMat.length > 0 ? apellidosMat[0].substring(0,1) : 'X');
        }
        else curpGenerada= curpGenerada + 'X';

        (this.informacionParaPadre.InformacionDeSolicitante.Nombres.trim().toUpperCase().split(' ')).forEach(nombre => {
          if (!palabrasIgnorar.includes(nombre)) { 
            nombres.push(this.simplificarNombreApellidos(nombre)); 
          }
        });

        if(nombres.length > 1)
        {
          curpGenerada = curpGenerada + (!nombresIgnorar.includes(nombres[0]) ? 
                           (nombres[0].substring(0,1)) :
                           (nombres[1].substring(0,1)));
        }
        else curpGenerada = curpGenerada + nombres[0].substring(0,1);

        /*const curpGenerada = (this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido.substring(0,1) + 
                           (this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido.match(/[AEIOU]/gi).length > 0? this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido[0].match(/[AEIOU]/gi) != null ? this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido.match(/[AEIOU]/gi)[1] : this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido.match(/[AEIOU]/gi)[0] : 'X') + 
                           (this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido)? this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido.substring(0,1) : 'X' ) + 
                           this.informacionParaPadre.InformacionDeSolicitante.Nombres.substring(0,1)).toUpperCase();*/

        
        return curpGenerada; 
      },
      /**
       * Función encargada de quitar ñ's, diéresis y acentos al texto
       */
      simplificarNombreApellidos:function(elemento)
      {
        return ((elemento.replace('Ñ','X'))
                               .normalize('NFD')
                               .replace(/([^n\u0300-\u036f]|n(?!\u0303(?![\u0300-\u036f])))[\u0300-\u036f]+/gi,"$1")
                               .normalize());
      },
      /**
       * Función encargada de verificar que la CURP tenga 18 caracteres y no esté vacia
       */
      verificarCURP:function()
      {
        return (this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.CURP) && this.informacionParaPadre.InformacionDeSolicitante.CURP.length == 18)
      },
      /**
       * Función encargada de verificar que el correo cumpla con el formato de correo y que si es correo de confirmación sea igual al ingresado anteriormente
       * @param {Bool} esConfirmacionDeCorreo [valor que representa si el correo a verificar es la confirmación de correo]
       * @param {Bool} mostrarMensajeError [valor que representa si se deben mostrar mensajes de error si hay alguno]
       */
      verificarCorreo:function(esConfirmacionDeCorreo, mostrarMensajesError)
      {
        let correoCorrecto = false;
        if((!esConfirmacionDeCorreo && this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico)) || (esConfirmacionDeCorreo && this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronicoConfirmar)))
        {
          if(!esConfirmacionDeCorreo)
          {
            correoCorrecto = comun.EsCorreoElectronico(this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico, false);
            
            this.seIngresoCorreo = correoCorrecto;
            if(!correoCorrecto)
            {
              this.mostrarMensajeConfirmacionCorreo = false;
              this.mensajeConfirmacionCorreo = "";
              this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronicoConfirmar = "";
              if(mostrarMensajesError)
              {
                this.mostrarMensajeCorreoPersonal = true;
                this.mensajeCorreoPersonal = "Correo no valido";
              }
            } 
            else{
              this.mostrarMensajeCorreoPersonal = false;
              this.mensajeCorreoPersonal = "";
            }
          }
          else{
            this.mostrarMensajeConfirmacionCorreo = false;
            this.mensajeConfirmacionCorreo = "";
            correoCorrecto = (this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico == this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronicoConfirmar);
            if(!correoCorrecto && mostrarMensajesError)
            {
              this.mostrarMensajeConfirmacionCorreo = true;
              this.mensajeConfirmacionCorreo = "Los correos no coinciden";
              //comun.mensajeDeAlerta("Los correos personales ingresados no son los mismos.<br/>Corrija el error e inténtelo de nuevo.", null, null);
            }
          }
        }
        else if(!esConfirmacionDeCorreo)
        {
          this.seIngresoCorreo = false;
        } 
        return correoCorrecto;
      },
      /**
       * Función encargada de validar que la fecha de nacimiento tenga un valor entro de un rango razonable
       * @param {String} fecha [valor que representa la fecha de nacimiento]
       */
      verificarFechaDeNacimiento:function(fecha)
      {
        return (this.campoNoEstaVacio(fecha) && this.fechaMinima < fecha && this.fechaMaxima > fecha);
      },
      /**
       * Función encargada de verificar que todos los campos estén llenados adecuadamente.
       */
      verificarCamposFormulario: function()
      {
        if(!this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.CURP))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar la CURP.';
          return false;
        }
        if(this.informacionParaPadre.InformacionDeSolicitante.CURP.length < 18)
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos incompletos, favor de ingresar la CURP completamente.';
          return false;
        }
        if(!this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.Nombres))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar el nombre o nombres.';
          return false;
        }
        if(!this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.PrimerApellido) && !this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.SegundoApellido))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar sus apellidos.';
          return false;
        }
        if(!this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.FechaDeNacimiento))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar la fecha de nacimiento';
          return false;
        }
        if(!this.verificarPorcentajeCoincidenciaCURP())
        {
          this.mensajeCamposFaltantes = 'La CURP no coincide con la información ingresada, favor de verificarlo e intentar de nuevo.';
          return false;
        }
        if(!this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar el correo electrónico personal.';
          return false;
        }
        if(!this.bloquearCampos.correo &&  !this.verificarCorreo(false, false))
        {
          this.mensajeCamposFaltantes = 'El correo electrónico personal es invalido, favor de verficar e intentar de nuevo.';
          return false;
        }
        if(!this.bloquearCampos.correo && this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico != this.informacionParaPadre.correoBase && !this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronicoConfirmar))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar la confirmación del correo electrónico personal.';
          return false;
        }
        if(!this.bloquearCampos.correo && this.informacionParaPadre.InformacionDeSolicitante.CorreoElectronico != this.informacionParaPadre.correoBase && !this.verificarCorreo(true, false))
        {
          this.mensajeCamposFaltantes = 'La confirmación del correo electrónico personal es invalido, favor de verficar e intentar de nuevo.';
          return false;
        }
        if((((this.conSesion && this.otrosDatosRadio) || (!this.conSesion && (this.informacionDeSolicitanteObtenida.Telefonos == undefined || this.informacionDeSolicitanteObtenida.Telefonos == null) && !this.informacionDeSolicitanteObtenida.EsAbogado)) && !this.campoNoEstaVacio(this.informacionParaPadre.InformacionDeSolicitante.Telefono)) || 
             (this.conSesion && this.datosUsuarioRadio && this.informacionDeUsuarioObtenida.Telefonos.length > 0 && !(this.idDeTelefono > 0)) || 
             (!this.conSesion && this.informacionDeSolicitanteObtenida.Telefonos != undefined && this.informacionDeSolicitanteObtenida.Telefonos != null && this.informacionDeSolicitanteObtenida.Telefonos.length > 0 && !(this.idDeTelefono > 0)))
        {
          this.mensajeCamposFaltantes = 'Se detectaron campos vacios, favor de ingresar el teléfono y de ser requerido la extensión.';
          return false;
        }
        if(((this.conSesion && this.otrosDatosRadio) || (!this.conSesion && (this.informacionDeSolicitanteObtenida.Telefonos == undefined || this.informacionDeSolicitanteObtenida.Telefonos == null) && !this.informacionDeSolicitanteObtenida.EsAbogado)) && this.informacionParaPadre.InformacionDeSolicitante.Telefono.length < 10)
        {
          this.mensajeCamposFaltantes = 'El teléfono debe contar con diez dígitos, favor de ingresar el teléfono completo y de ser requerido la extensión.';
          return false;
        }
        return true;
      },
      /**
       * Función encargada de obtener el texto concatenado de teléfono y extensión para mostrar en el select de teléfonos
       * @param {String} telefono [telefono]
       * @param {String} extension [extension]
       */
      obtenerTextoOpcionTelefono:function (telefono, extension){
        if(extension != undefined || extension!= null)
        {
          return telefono.match(/[0123456789]/gi).join("") + ", Extension:" + extension;
        }
        return telefono.match(/[0123456789]/gi).join("");
      },
      /**
       * Función encargada de limpiar el formulario cuando no se encuentra información de CURP pero había información existente
       * @param {Object} datos [Objeto de Información de solicitante que se limpiará]
       * @param {String} CURP [Valor de CURP que se designará]
       */
      limpiarInformacion:function(datos, CURP)
      {
        datos.CURP= CURP;
        datos.InformacionDeSolicitanteId = null;
        datos.Nombres="";
        datos.PrimerApellido="";
        datos.SegundoApellido="";
        datos.CorreoElectronico="";
        datos.FechaDeNacimiento=null;
        datos.Telefono="";
        datos.Extension="";
        datos.bloquearCampos.fechaDeNacimiento = false;
        datos.bloquearCampos.nombreApellidos = false;
        datos.bloquearCampos.CURP = false;
        datos.bloquearCampos.correo = false;
      }
    },
    beforeMount() {
      this.parametros = {ObtenerInformacionDeUsuario : true, ObtenerInformacionDeCURP: false}
      this.obtenerInformacionSesionCURP();
    }
  }
</script>

<style scoped>
  .contenedor-puntero {
        background: #636369;
        border-radius:2px;
        padding: 10px;
        border:1px solid black;
        margin-bottom: 1.5em;
  }

  .padding-div-low {
    padding-top: 40px;
  }

  a {
    cursor: pointer;
    text-decoration: none;
  }

  .btn-group-toggle{
    margin-bottom: 1.5em;
  }
  .btn-secondary:not(:disabled):not(.disabled).active, .btn-secondary:not(:disabled):not(.disabled):active, .show>.btn-secondary.dropdown-toggle {
    color: white;
    background-color: #57585B;
    border-color: white;
  }
  .btn-secondary {
    color: rgb(106, 108, 112);
    background-color: #323335;
    border-color: rgb(106, 108, 112);
    font-size: 0.95rem;
  }
  .btn-secondary:hover {
    color: white;
    background-color: #323335;
    border-color: white;
  }
  .form-control:disabled, .form-control[readonly]
  {
    background-color: #3D3C40 !important;
    pointer-events: none;
    color: #aaa;
  }
  .textoMayusculas{
    text-transform: uppercase;
  }

  .form-control {
        background-color: white;
        color: rgb(63, 62, 62);
        border: 1px solid #656161 !important;
    }   

    .card-body {
        background-color: #bebebc;
        padding: 2em 2em 2em 2em !important;
        border: 1px solid rgb(44, 44, 44);
    }

    .card-header {
        background-color: #007573;
        border: 1px solid rgb(44, 44, 44);
        
    }
    .text-form {
        padding:10px; 
        line-height: 1; 
        color: black;
    }
</style>



// WEBPACK FOOTER //
// src/components/SICCIJ/Citas/AgendarCitas/DatosDeUsuarioSolicitante.vue